module.exports = __webpack_public_path__ + "media/images/flags/64/Tokelau-ce71f2e49edd931c0139765a5213188d.png";